import { Link, useLocation } from "react-router-dom"
import { useState } from "react"

export default function Header() {
    const [isMenuOpen, setIsMenuOpen] = useState(false)
    const location = useLocation()

    const links = [
        {
            link: '/',
            title: 'Home'
        },
        //  {
        //     link: '/about',
        //     title: 'About'
        // },
        {
            link: '/works',
            title: 'Works'
        },
        // {
        //     link: '/portfolio',
        //     title: 'Portfolio'
        // },
        {
            link: '/ai-platform',
            title: 'AI Platform'
        }
    ]

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen)
    }

    const closeMenu = () => {
        setIsMenuOpen(false)
    }

    return (
        <div className="w-full mx-auto bg-transparent relative top-0 left-0 right-0 z-[9999] p-4 md:p-16 md:py-12 ">
            <div className="flex items-center justify-between">
                {/* Logo */}
                <div className="flex-shrink-0">
                    <Link to="/" onClick={closeMenu}>
                        <img className="w-14 sm:w-20 lg:w-20 h-auto" src="/logo/logo-1.png" alt="Logo" />
                    </Link>
                </div>

                {/* Desktop Navigation */}
                <div className="hidden md:flex items-center">
                    {links.map((item, index) => (
                        <div key={index} className="flex items-center">
                            <Link
                                to={item.link}
                                className={`px-3 lg:px-4 py-2 transition-colors text-sm duration-200 ${location.pathname === item.link
                                    ? 'font-semibold text-white'
                                    : 'text-gray-200 hover:text-brand-orange'
                                    }`}
                            >
                                {item.title}
                            </Link>
                            {/* Add divider line between desktop links */}
                            {index < links.length - 1 && (
                                <div className="w-px h-4 bg-gray-400 mx-2"></div>
                            )}
                        </div>
                    ))}
                </div>

                {/* Desktop Contact Button */}
                <div className="hidden md:block flex-shrink-0">
                    <Link to="/contact" onClick={closeMenu} className="">
                        <button className="orange text-sm sm:text-base px-3 sm:px-4 py-2">
                            Contact Us
                        </button>
                    </Link>
                </div>



                {/* Mobile Menu Button */}
                <div className="md:hidden flex-shrink-0 ml-2">
                    <button
                        onClick={toggleMenu}
                        className="border-none text-white hover:text-brand-orange focus:outline-none focus:text-brand-orange transition-colors duration-200 p-1"
                        aria-label="Toggle menu"
                    >
                        <svg
                            className="w-6 h-6"
                            fill="none"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            {isMenuOpen ? (
                                <path d="M6 18L18 6M6 6l12 12" />
                            ) : (
                                <path d="M4 6h16M4 12h16M4 18h16" />
                            )}
                        </svg>
                    </button>
                </div>
            </div>

            {/* Mobile Navigation Menu */}
            {isMenuOpen && (
                <div className="md:hidden mt-4 pb-4 bg-white/95 backdrop-blur-sm rounded-lg shadow-lg">
                    <div className="flex flex-col">
                        {links.map((item, index) => (
                            <Link
                                key={index}
                                to={item.link}
                                onClick={closeMenu}
                                className={`px-4 py-4 border-b border-gray-200 last:border-b-0 transition-colors duration-200 ${location.pathname === item.link
                                    ? 'text-brand-orange font-semibold bg-orange-50'
                                    : 'text-gray-800 hover:text-brand-orange hover:bg-gray-50'
                                    }`}
                            >
                                {item.title}
                            </Link>
                        ))}

                    </div>
                </div>
            )}

            {/* Floating Contact Button for Mobile */}
            <div className="md:hidden bg-black w-full p-4 border-t border-gray-700 fixed bottom-0 left-0 right-0 z-[10000] bg-gradient-to-t from-black/60 to-transparent pointer-events-none">
                <div className="flex justify-between items-center pointer-events-auto">
                    <span className="relative z-10 block text-xs text-gray-300 italic">"Let's build something amazing together"</span>
                    <Link to='/contact'>
                        <button className="whitespace-nowrap orange !text-xs py-0 px-6 text-white font-semibold relative overflow-hidden shadow-2xl py-2 shadow-white/10 border border-white/20 rounded-lg">
                            Contact Us
                            {/* Glow animation */}
                            {/* <div className="absolute inset-0 bg-gradient-to-r from-white/5 via-white/10 to-white/5 animate-ping opacity-75"></div>
                        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent animate-pulse"></div>
                        <div className="absolute -inset-1 bg-gradient-to-r from-white/20 to-gray-300/20 blur-sm animate-pulse opacity-40"></div> */}
                        </button>
                    </Link>
                </div>
            </div>
        </div>
    )
}